function polyfillGetUserMedia() {
	if (typeof navigator === 'undefined') {
		return null;
	}

	if (!navigator.mediaDevices) {
		navigator.mediaDevices = {};
	}

	if (!navigator.mediaDevices.getUserMedia) {
		const legacyGetUserMedia = navigator.getUserMedia ||
			navigator.webkitGetUserMedia ||
			navigator.mozGetUserMedia;

		if (!legacyGetUserMedia) {
			return null;
		}

		navigator.mediaDevices.getUserMedia = (constraints) => new Promise((resolve, reject) => {
			legacyGetUserMedia.call(navigator, constraints, resolve, reject);
		});
	}

	return navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);
}

function requestCameraStream() {
	const getUserMedia = polyfillGetUserMedia();

	if (!getUserMedia) {
		return Promise.reject(new Error('Camera is not supported on this device.'));
	}

	const constraints = [
		{ video: { facingMode: 'user' }, audio: false },
		{ video: true, audio: false }
	];

	const tryConstraint = (index) => {
		if (index >= constraints.length) {
			return Promise.reject(new Error('Could not access camera. Please allow camera permission and try again.'));
		}

		return getUserMedia(constraints[index]).catch(() => tryConstraint(index + 1));
	};

	return tryConstraint(0);
}

function attachStreamToVideo(video, stream) {
	if (!video) return;

	video.srcObject = stream;
	const playPromise = video.play();
	if (playPromise && typeof playPromise.catch === 'function') {
		playPromise.catch(() => {});
	}
}

export default {
	requestCameraStream,
	attachStreamToVideo
};
